import { Link } from "react-router-dom";
import { LOGO_URL, DOMAIN } from "@/lib/constants";
import { useLang } from "@/i18n/LanguageContext";
import { getLegalUI } from "@/i18n/legal";

export function Footer() {
  const { t, lang } = useLang();
  const ui = getLegalUI(lang);
  return (
    <footer data-testid="site-footer" className="relative z-10 border-t border-white/10 bg-[#050505]">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <img src={LOGO_URL} alt="AURA+" className="h-14 w-auto mix-blend-screen opacity-95 mb-6" />
            <p className="max-w-sm text-zinc-500 text-sm leading-relaxed">{t("footer.tagline")}</p>
            <p className="mt-4 text-xs text-zinc-600">AURORA VG SRL · P.IVA 08866110722</p>
          </div>
          <div className="flex flex-col gap-2 text-sm text-zinc-500">
            <span className="text-xs uppercase tracking-[0.2em] text-zinc-600 mb-2">{t("footer.contacts")}</span>
            <a href={`https://${DOMAIN}`} className="hover:text-white transition-colors">{DOMAIN}</a>
            <a href={`mailto:creators@${DOMAIN}`} className="hover:text-white transition-colors">creators@{DOMAIN}</a>
          </div>
          <div className="flex flex-col gap-2 text-sm text-zinc-500">
            <span className="text-xs uppercase tracking-[0.2em] text-zinc-600 mb-2">{ui.legalLinks}</span>
            <Link to="/privacy" data-testid="footer-privacy" className="hover:text-white transition-colors">{ui.privacy}</Link>
            <Link to="/cookie" data-testid="footer-cookie" className="hover:text-white transition-colors">{ui.cookie}</Link>
            <Link to="/termini" data-testid="footer-terms" className="hover:text-white transition-colors">{ui.terms}</Link>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-zinc-600">
          <span>© {new Date().getFullYear()} AURA+. {t("footer.rights")}</span>
          <span className="tracking-[0.2em] uppercase">{t("footer.program")}</span>
        </div>
      </div>
    </footer>
  );
}
